import Swiper, { Navigation, Pagination, Lazy } from "swiper";
Swiper.use([Navigation, Pagination, Lazy]);

const initHrFeedbackSlider = () => {
  const slider = document.querySelector("[data-hr-feedback] .cases-slider");

  if (!slider) return;

  slider &&
    new Swiper(slider, {
      watchOverflow: true,
      spaceBetween: 20,
      slidesPerView: 3,
      lazy: true,

      breakpoints: {
        997: {
          slidesPerView: 3,
        },
        660: {
          slidesPerView: 2,
        },
        0: {
          spaceBetween: 10,
          slidesPerView: 1.2,
        },
      },

      navigation: {
        nextEl: "[data-hr-feedback] .cases-slider__navigation-next",
        prevEl: "[data-hr-feedback] .cases-slider__navigation-prev",
        disabledClass: "last",
      },
      pagination: {
        el: "[data-hr-feedback] .swiper-pagination",
        type: "fraction",
      },
    });

    const videoReviews = slider.querySelectorAll('.cases__video-item');

    videoReviews?.forEach((videoReview) => {
      videoReview?.addEventListener("mouseover", () => videoReview.querySelector("video")?.play());

      videoReview?.addEventListener("mouseleave", () => videoReview.querySelector("video")?.pause());
    });
};

export default initHrFeedbackSlider;
